<template>
  <Card :title="$t('global.your-services')" :height100="false">
    <CardTabledList>
      <tr v-for="(item, index) in getProtections()" :key="index">
        <td>
          <div class="d-inline-flex flex-wrap">
            <div class="mr-1">{{ item.title }}</div>
            <LearnMore
              class="help-icon"
              :help="{ title: item.help, link: cardHelpLink(item.link) }"
            />
          </div>
        </td>
        <td>
          <div class="d-inline-flex">
            <Logo :logo="item.icon" :size="50" />
            <Icon :size="15" icon="success" color="sigma" />
          </div>
        </td>
      </tr>
    </CardTabledList>
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import CardTabledList from "@/components/display/card-sub-components/CardTabledList";
import Icon from "@/components/display/icon/Icon";
import LearnMore from "@/components/display/LearnMore";
import Logo from "@/components/display/Logo";
import NavLink from "@/classes/NavLink";

export default {
  name: "SafeHarborThreatProtectionServices",
  components: {
    Card,
    CardTabledList,
    Icon,
    LearnMore,
    Logo,
  },
  setup(props, { root }) {
    const getProtections = () => [
      {
        title: root.$t("global.web-application-firewall"),
        help: root.$t("global.safe-harbor-ticket-firewall"),
        icon: "safe-harbor-firewall",
        link:
          "https://help.nexcess.net/77283-other-best-practices/what-is-a-web-application-firewall",
      },
      {
        title: root.$t("global.real-time-ip-blacklist"),
        help: root.$t("global.safe-harbor-ticket-ip"),
        icon: "safe-harbor-ip",
        link: "https://help.nexcess.net/real-time-ip-blacklist",
      },
      {
        title: root.$t("global.bad-bot-rate-limiting"),
        help: root.$t("global.safe-harbor-ticket-bad-bots"),
        icon: "safe-harbor-bad-bot",
        link: "https://help.nexcess.net/74107-reports-and-monitoring/how-nexcess-limits-bad-bots",
      },
    ];

    const cardHelpLink = (link) => [
      new NavLink(
        "Learn More",
        null,
        () => window.open(link, "_blank", "noopener, noreferrer"),
        false,
        null,
        null
      ),
    ];

    return {
      cardHelpLink,
      getProtections,
    };
  },
};
</script>
